export const env = process.env.ENV;

export const isProd = env.includes('prod');
